import { FlyerDetailPageFormPageState } from "./flyer-detail-page-form-page-state.interface";

export function createFlyerDetailPageFormPageState(): FlyerDetailPageFormPageState {
  return {
    page: null,
    isLoading: false,
  };
}
